(function ($) {
    $(document).ready(function () {
        var videoSrc;

        $('.video-popup').magnificPopup({
            type: 'iframe',
            iframe: {
                markup: '<div class="mfp-iframe-scaler">' +
                           '<div class="mfp-close"></div>'+
                           '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                           '<div class="mfp-description"></div>'+
                         '</div>'
            },
            mainClass: 'video-gallery-iframe',
            callbacks: {
                markupParse: function (template, values, item) {
                    values.close = '<span class="mfp-title pull-left">' + item.el.attr('title') + '</span>' + '<button title="Close (Esc)" type="button" class="mfp-close pull-right close-button" style="color: #af1e2d; padding-right: 10px !important; cursor: pointer; top: -68px; left: -10px !important; opacity: 1 !important; position: relative; width: 45px; font-size: 40px;">×</button>';
                    values.description = item.el.attr('description') || item.el.attr('title');
                }
            }
        })

        $(".video-btn").on("click", function () {
            videoSrc = $(this).attr("data-src");
            $("#video").attr('src', videoSrc);
        });

        // this is needed in order to get the video to stop playing when exiting modal
        $('#videoModal').on('hide.bs.modal', function (e) {
            $("#video").attr('src', videoSrc);
        })
    });
})(jQuery);